var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEraserLine(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_34_7833)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.58602 8.85797L3.63602 13.808L8.83002 19.002H10V19H11.172L14.95 15.222L8.58602 8.85797ZM10 7.44397L16.364 13.808L19.192 10.979L12.828 4.61497L10 7.44397ZM14 19H21V21H12L8.00202 21.002L1.51502 14.515C1.32754 14.3274 1.22223 14.0731 1.22223 13.808C1.22223 13.5428 1.32754 13.2885 1.51502 13.101L12.12 2.49397C12.2129 2.40099 12.3232 2.32723 12.4446 2.27691C12.566 2.22659 12.6961 2.20068 12.8275 2.20068C12.9589 2.20068 13.0891 2.22659 13.2105 2.27691C13.3319 2.32723 13.4421 2.40099 13.535 2.49397L21.313 10.272C21.5005 10.4595 21.6058 10.7138 21.6058 10.979C21.6058 11.2441 21.5005 11.4984 21.313 11.686L14 19Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_34_7833"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEraserLine);
export default __webpack_public_path__ + "static/media/eraser-line.ce6fc54685f87e76d369ed8eb470aee2.svg";
export { ForwardRef as ReactComponent };